export default __webpack_public_path__ + "static/media/img_rentcar_01_pc.7c23838c.png";